var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59999 13.6C3.26999 13.6 2.98749 13.4825 2.75249 13.2475C2.51749 13.0125 2.39999 12.73 2.39999 12.4V3.6C2.39999 3.27 2.51749 2.9875 2.75249 2.7525C2.98749 2.5175 3.26999 2.4 3.59999 2.4H7.39999C7.56999 2.4 7.71249 2.45716 7.82749 2.57148C7.94249 2.68582 7.99999 2.82748 7.99999 2.99648C7.99999 3.16549 7.94249 3.30833 7.82749 3.425C7.71249 3.54167 7.56999 3.6 7.39999 3.6H3.59999V12.4H12.4V8.6C12.4 8.43 12.4572 8.2875 12.5715 8.1725C12.6858 8.0575 12.8275 8 12.9965 8C13.1655 8 13.3083 8.0575 13.425 8.1725C13.5417 8.2875 13.6 8.43 13.6 8.6V12.4C13.6 12.73 13.4825 13.0125 13.2475 13.2475C13.0125 13.4825 12.73 13.6 12.4 13.6H3.59999ZM12.4 4.45L6.86666 9.98333C6.74444 10.1056 6.60555 10.1639 6.44999 10.1583C6.29444 10.1528 6.15555 10.0889 6.03333 9.96667C5.91111 9.84444 5.84999 9.70278 5.84999 9.54167C5.84999 9.38056 5.91111 9.23889 6.03333 9.11667L11.55 3.6H10.2C10.03 3.6 9.88749 3.54284 9.77249 3.42852C9.65749 3.31418 9.59999 3.17252 9.59999 3.00352C9.59999 2.83451 9.65749 2.69167 9.77249 2.575C9.88749 2.45833 10.03 2.4 10.2 2.4H13.6V5.8C13.6 5.97 13.5428 6.1125 13.4285 6.2275C13.3142 6.3425 13.1725 6.4 13.0035 6.4C12.8345 6.4 12.6917 6.3425 12.575 6.2275C12.4583 6.1125 12.4 5.97 12.4 5.8V4.45Z",
    fill: "#007C66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.221f76f06035d69ca9c3384a06fefb4d.svg";
export { ForwardRef as ReactComponent };